export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=409d8a35adf223179793ea2673185f3498b00b711f&name=revalidateCommunity!'